import * as angular from 'angular';
import { partition } from '../../common';

/**
 * This service is a wrapper around $http cache from angular
 * It holds a copy of all keys stored in the cache
 * Allow to remove some cache entry based on patterns
 */
export interface ICacheService extends angular.ICacheObject {
    removeStartingWith(key: string);
}

export class CacheService implements ICacheService {
    static serviceId = 'cacheService';

    private _keys: string[] = [];

    static $inject = ['$cacheFactory'];

    constructor(
        private _$cacheFactory: angular.ICacheFactoryService,
    ) {
    }

    private cache(): angular.ICacheObject {
        return this._$cacheFactory.get('$http');
    }

    info(): { id: string; size: number } {
        return this.cache()?.info();
    }

    put<T>(key: string, value?: T): T {
        this._keys.push(key);
        return this.cache()?.put(key, value);
    }

    get<T>(key: string): T {
        return this.cache()?.get(key);
    }

    remove(key: string): void {
        this._keys = this._keys.filter(k => k !== key);
        return this.cache()?.remove(key);
    }

    removeStartingWith(key: string) {
        const cache = this.cache();
        const { keep, remove } = partition(this._keys, k => !k.startsWith(key));
        remove.forEach(o => cache?.remove(o));
        this._keys = keep;
    }

    removeAll(): void {
        this._keys = [];
        this.cache()?.removeAll();
    }

    destroy(): void {
        this._keys = [];
        this.cache()?.destroy();
    }
}